// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import map01Icon from "@/assets/icons/map-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Map01IconProps = Omit<IconProps, "name">;

export function Map01Icon(props: Map01IconProps): React.ReactNode {
  return <Icon name={map01Icon} {...props} />;
}
